/**
 * ChevronDownIcon/index.js
 * desc: navigation down arrow
 * note: action icon via IconButton; defaults its tooltip + accessible name to the
 *       action label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const ChevronDownIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="chevron-down icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.chevronDown.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 12 8" xmlns="http://www.w3.org/2000/svg"><path d="M10.59.59L6 5.17 1.41.59 0 2l6 6 6-6L10.59.59z"/></svg>
    </IconButton>
);


export default ChevronDownIcon;
